// general
import * as bootstrap from '../../node_modules/bootstrap/dist/js/bootstrap.js'

window.bootstrap = bootstrap;
import './authentication';
import './menu';
import './tabs';
import './form';
import './functions';
// fields
import './meta_data';
import './google_maps';
import './brand_products';
import './surfaces';
import './project_fields';
import './locations';
